import { Injectable, OnInit } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { identityUrl } from 'src/environments/environment';

@Injectable()
export class TransactionSigningIdentityInterceptor implements HttpInterceptor {
  issuerUrl: string;
  constructor() {
    this.issuerUrl = identityUrl || "https://identity.bancadigitaldev.banesco.com.do";
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Verificar si la solicitud es para la URL específica y contiene los parámetros necesarios
    if (
      request.url.includes(
        `${this.issuerUrl}/auth/realms/banesco-retail/protocol/openid-connect/auth`
      ) &&
      request.params.has('code_challenge') &&
      request.params.has('code_challenge_method')
    ) {
      // Obtener los valores de las cookies
      const keycloakSession = this.getCookie('KEYCLOAK_SESSION');
      const authSession = this.getCookie('AUTH_SESSION_ID');
      const keycloakIdentityLegacy = this.getCookie('KEYCLOAK_IDENTITY_LEGACY');
      const keycloakIdentity = this.getCookie('KEYCLOAK_IDENTITY');

      // Si se encuentran los valores en las cookies, agregarlos al encabezado de la solicitud
      if (
        authSession &&
        keycloakSession &&
        keycloakIdentity &&
        keycloakIdentityLegacy
      ) {
        request = request.clone({
          withCredentials: true, // Asegurar que las cookies se incluyan en la solicitud
          setHeaders: {
            Cookie: `AUTH_SESSION_ID=${authSession}; AUTH_SESSION_ID_LEGACY=${authSession}; KEYCLOAK_SESSION=${keycloakSession} KEYCLOAK_SESSION_LEGACY=${keycloakSession}; KEYCLOAK_IDENTITY=${keycloakIdentity} KEYCLOAK_IDENTITY_LEGACY=${keycloakIdentityLegacy};`,
          },
        });
      }
    }

    // Continuar con la solicitud
    return next.handle(request);
  }

  // Función para obtener el valor de una cookie por su nombre
  private getCookie(name: string): string | null {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift() || null;
    return null;
  }
}
